var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#747b26",
    d: "M12 17q-.425 0-.737-.312q-.313-.313-.313-.738t.313-.737q.312-.313.737-.313t.738.313q.312.312.312.737t-.312.738Q12.425 17 12 17Zm-.75-3.2q0-1.15.188-1.575q.187-.425 1.062-1.175q.35-.35.6-.688q.25-.337.25-.762q0-.45-.337-.8q-.338-.35-1.013-.35q-.675 0-1.025.387q-.35.388-.475.813L9.15 9.1q.3-.875 1.025-1.488Q10.9 7 12 7q1.175 0 2.013.637q.837.638.837 1.913q0 .6-.3 1.125t-.75.975q-.75.75-.9 1.05q-.15.3-.15 1.1ZM7 23q-.825 0-1.412-.587Q5 21.825 5 21V3q0-.825.588-1.413Q6.175 1 7 1h10q.825 0 1.413.587Q19 2.175 19 3v18q0 .825-.587 1.413Q17.825 23 17 23Zm0-5h10V6H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDevice);
export default __webpack_public_path__ + "static/media/ic_device.d8995e033a676ceb03dd6554ad3e0d8c.svg";
export { ForwardRef as ReactComponent };